module.exports = __webpack_public_path__ + "fonts/MyriadPro-Regular.17caf326.otf";